import React, { memo } from 'react';
import { Platform, View, TouchableWithoutFeedback, StyleSheet } from 'react-native';
import { colorPalette } from '../../../core/config/color.config';
import { SVGIcon, RNEText, IconName } from '../../components';
import { width, height, totalSize } from 'react-native-dimension';
import { Image } from 'react-native';
import ConsultationIcon from '../../../assets/images/consultation_icon.png';

interface SideMenuItemProps {
  label: string;
  active: boolean;
  iconName?: IconName;
  hideLabel?: boolean;
  disabled?: boolean;
  onPress?: () => void;
}

const SideMenuItem = (props: SideMenuItemProps) => {
  const getIconSize = () => {
    if (props.iconName === 'copy') {
      return Platform.OS === 'web' ? totalSize(1.4) : totalSize(2);
    }else if(props.iconName == 'consultation-icon'){
      return Platform.OS === 'web' ? totalSize(1.4) : totalSize(0.1);
    } else {
      return Platform.OS === 'web' ? totalSize(1.4) : totalSize(2.5);
    }
  };

  return (
    <TouchableWithoutFeedback disabled={props.disabled} onPress={() => props.onPress?.()}>
      <View style={styles.contentItemWrapper}>
        <View style={styles.contentItem} accessibilityRole="button">
          {props.disabled && (
            <View
              style={[
                styles.contentItemOverlay,
                props.hideLabel && styles.contentItemOverlayCompressed,
              ]}
            />
          )}

          {props.iconName && props.iconName !== 'consultation-icon' && (
            <View style={[!props.hideLabel && styles.iconContainer, props.hideLabel && styles.collapsedIconContainer]}>
              <SVGIcon name={props.iconName} size={getIconSize()} />
            </View>
          )}

          {props.iconName && props.iconName === 'consultation-icon' && (
            <View style={[!props.hideLabel && styles.iconContainer, props.hideLabel && styles.collapsedIconContainer]}>
              <Image
                source={ConsultationIcon}
                style={{width: width(6), height: width(6)}}
                resizeMode='contain'
              />
            </View>
          )}

          {!props.hideLabel && (
            <View style={styles.labelContainer}>
              <RNEText
                label={props.label}
                variant="body"
                color={
                  props.active
                    ? Platform.OS === 'web'
                      ? 'black'
                      : 'primary'
                    : 'black'
                }
                weight={props.active ? 'bold' : '400'}
                style={[
                  {
                    fontSize: Platform.OS === 'web' ? totalSize(1) : totalSize(1.6),
                    fontFamily: 'Quicksand-SemiBold',
                  },
                  (Platform.OS === 'android' || Platform.OS === 'ios') && {marginTop: -height(1)},
                  // props.iconName === 'copy' && { marginBottom: height(1.5) },
                  Platform.OS === 'web' && { marginBottom: height(1.5) },
                ]}
              />
            </View>
          )}
        </View>

        {/* Active underline */}
        {Platform.OS === 'web' && props.active && !props.hideLabel && <View style={styles.activeLine} />}
        {Platform.OS === 'web' && props.active && props.hideLabel && <View style={styles.collapsedActiveLine} />}
      </View>

    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  collapsedIconContainer:{
    marginBottom: height(3),
    // marginLeft: height(0.6)
  },
  contentItemWrapper: {
    position: 'relative',
    paddingLeft: width(0.8),
    marginBottom: Platform.OS !== 'web' ? height(1.5) : height(1),
  },
  contentItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  activeLine: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: height(0.2),
    backgroundColor: colorPalette.primary,
    opacity: totalSize(0.03)
  },
  collapsedActiveLine:{
    maxWidth: width(3),
    position: 'absolute',
    bottom: height(1),
    left: width(0.1),
    right: 0,
    height: 2,
    backgroundColor: colorPalette.primary,
    opacity: totalSize(0.04)
  },
  iconContainer: {
    width: Platform.OS === 'web' ? width(2.2) : width(10),
    marginTop: Platform.OS === 'web' ? 0 : height(1),
  },
  labelContainer: {
    flex: 1,
    padding: height(0.5),
    paddingLeft: Platform.OS === 'web' ? width(0) : width(4),
    marginTop: height(1.5),
    alignSelf:'center'
  },
  contentItemOverlay: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    position: 'absolute',
    backgroundColor: colorPalette.white,
    zIndex: 1,
    opacity: 0.6,
  },
  contentItemOverlayCompressed: {
    width: 50,
  },
});

export default memo(SideMenuItem);
